import { DEFAULT_DATETIME_FORMAT } from '@/components/constants';
import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';
import { useCallback, useMemo } from 'react';

export function useCurrentTime() {
  const timezone = useMemo(() => {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
      return 'UTC'; // Fallback timezone
    }
  }, []);

  const getCurrentTime = useCallback(
    (dateTimeFormat: string = DEFAULT_DATETIME_FORMAT) => {
      try {
        const zonedDate = new TZDate(new Date(), timezone);
        return format(zonedDate, dateTimeFormat);
      } catch {
        return format(new Date(), dateTimeFormat); // Fallback formatting
      }
    },
    [timezone]
  );
  return { getCurrentTime };
}
